import { localStorageInstance } from "./localStorage";

export function getStoredValue(key, sessionStorageKey = key) {
  return sessionStorage.getItem(sessionStorageKey) || localStorageInstance.getItem(key);
}

export function isStoredRole(role) {
  return getStoredValue("role") === role;
}
